/* eslint-disable */
import { withStyles } from '@material-ui/core'
import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import LinearProgress from '@material-ui/core/LinearProgress'
import MuiLink from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth'
import AddIcon from '@material-ui/icons/Add'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import PhoneIcon from '@material-ui/icons/Phone'
import cn from 'classnames'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import React, { useRef, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { UI_FAB_PLACE_ORDER_CLICK, UI_PLUS_LOAD_TRUCKS_PANE_GET_BTN } from '../../State/Store/UI/UI.types'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
import withServices from '../../Contexts/Services/WithServices.context'
import { createPlaceOrderPageLink } from '../../Pages/PlaceOrder/PlaceOrder.page.route'
import { ORDER_DETAILS_POLLING_INTERVAL } from '../../Services/Order/Order.service.constants'
import ordersActionCreators from '../../State/Store/Orders/Orders.actions'
import orderConcreteDeliveriesStatus from '../../State/Store/Orders/Selectors/OrderConcreteDeliveriesStatus.selector'
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector'
import uiActionCreators from '../../State/Store/UI/UI.actions'
import envGet from '../../Support/Env/Get/EnvGet.support'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import I18n from '../I18n/I18n.component'
import KeyValueDateTimeField from '../KeyValueDateTimeField/KeyValueDateTimeField.component'
import KeyValuePairs from '../KeyValuePairs/KeyValuePairs.component'
import OrderActions from '../OrderActions/OrderActions.component'
import OrderConcreteDeliveriesDeliveredSection from '../OrderConcreteDeliveriesDeliveredSection/OrderConcreteDeliveriesDeliveredSection.component'
import OrderConcreteDeliveriesInTransitSection from '../OrderConcreteDeliveriesInTransitSection/OrderConcreteDeliveriesInTransitSection.component'
import OrderConcreteDeliveriesScheduledSection from '../OrderConcreteDeliveriesScheduledSection/OrderConcreteDeliveriesScheduledSection.component'
import SpeedDialWrapperComponent from '../SpeedDialWrapper/SpeedDialWrapper.component'
import orderConcreteDeliveriesStyles from './OrderConcreteDeliveries.component.styles'
import moment from 'moment'
import { ORDER_STATUS_CANCELLED, ORDER_STATUS_NEW } from 'Constants/Order/Order.constants'
import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate'
import { createActionOpenPlusLoadModal } from 'State/Store/PlusLoadModal/PlusLoadModalActionCreatorsMapping'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { ReduxRoot, DeliveryDetailOutter } from 'types/ReduxStore'
import { Order, PlusLoadStatus } from 'types/Order'
import { getSpeedDialCallBoralOption, getSpeedDialPlaceOrderOption } from 'Components/SpeedDialWrapper/SpeedDialOptions'
import { createInjectedActionOrdersFindByStatus } from 'State/Store/Orders/Actions/OrdersFindByStatus.action'
import { shouldShowPlusLoad } from 'Components/OrderDetailsHeader/parts/utils/should-show-plus-load'
import { formatPlusLoadQuantityTextByStatus } from 'ui-format-utils.ts/format-plus-load-quantity-text-by-status'
import { UI_TEXT_GET_A_PLUS_LOAD } from 'ui-format-utils.ts/ui-text/get-a-plus-load'
import { checkThenOpenPlusLoadModal } from 'Components/OrderDetailsHeader/utils/check-then-open-plus-load-modal'

const FEATURE_TOGGLE_FAB_BUTTONS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_FAB_BUTTONS` }) as string === `true`

interface Props {
  orderId: string,
}

interface InjectedProps {
  services: any,
  classes: any,
  width: any,
  history: any,
  selectedOrderLoading: boolean,
  currentDeliveryDetails: any,
}

const OrderConcreteDeliveriesComponent = (props: Props & InjectedProps) => {
  const {
    orderId,
    selectedOrderLoading,
    // currentDeliveryDetails,

    services,
    classes,
    width,
    history,
  } = props
  const currentOrder: Order = useSelector((root: ReduxRoot) => root.orders.entities[orderId])
  const deliveryDetailId = `DELIVERED,INTRANSIT,SCHEDULED-${currentOrder.summary.orderCode}-${currentOrder.summary.orderLine}`
  const currentDeliveryDetails: DeliveryDetailOutter = useSelector((root: ReduxRoot) => (root.orders as any)[deliveryDetailId])
  const dispatch = useDispatch()
  const preserveScrollRef = useRef<any>()
  const ORDER_CONCRETE_DELIVERIES_SUMMARY_FIELDS_MAPPING = [
    [
      `summary.startTime`,
      `OrderService.OrderDetails.Labels.Date`,
      ({ InputProps, label, value }: any) => (
        <KeyValueDateTimeField formatString='h:mm a, ddd D MMM YYYY' GridItemProps={{ sm: 5 }} InputProps={InputProps} label={label} value={value} />
      ),
    ],
    [`details.deliveryAddress`, `OrderService.OrderDetails.Labels.DeliveryAddress`],
  ]


  const ORDER_CONCRETE_DELIVERIES_PRODUCT_FIELDS_MAPPING = [[`details.product`, `OrderService.OrderDetails.Labels.ProductDetails`]]

  useEffect(() => {
    requestConcreteDeliveriesDetails()
    const pollingId = setInterval(() => {
      requestConcreteDeliveriesDetails()
    }, ORDER_DETAILS_POLLING_INTERVAL)
    return () => {
      clearInterval(pollingId)
    }
  }, [])

  const requestConcreteDeliveriesDetails = () => {
    if (!services.authService.isAuthenticated()) {
      return
    }
    const { summary } = currentOrder || {}
    if (!summary) {
      return
    }
    const { orderCode, orderLine } = summary
    const requestPayload = {
      orderCode,
      orderLine,
      status: `DELIVERED,INTRANSIT,SCHEDULED`,
    }
    dispatch(createInjectedActionOrdersFindByStatus(requestPayload))
  }

  const renderLoader = () => {
    return (
      <Fade in={selectedOrderLoading}>
        <LinearProgress className={classes.loader} />
      </Fade>
    )
  }

  const renderError = () => {
    return (
      <Grid alignContent='center' alignItems='center' classes={{ container: classes.errorMessageContainer }} container justify='center'>
        <ErrorOutlineIcon className={classes.errorIcon} />
        <I18n>OrderService.OrderDetails.ErrorMessage</I18n>
      </Grid>
    )
  }

  const renderSummary = () => {
    return (
      <Grid classes={{ container: classes.summaryContainer }} container direction='column' spacing={1}>
        <KeyValuePairs
          fieldsMapping={ORDER_CONCRETE_DELIVERIES_SUMMARY_FIELDS_MAPPING}
          GridContainerProps={{ classes: { container: classes.summaryItem }, direction: `row` }}
          keyValuePairs={currentOrder}
        />
        <KeyValuePairs
          fieldsMapping={ORDER_CONCRETE_DELIVERIES_PRODUCT_FIELDS_MAPPING}
          keyValuePairs={currentOrder}
        />
      </Grid>
    )
  }

  const renderCallToActionSection = (currentOrder: any) => {
    if (!currentOrder) {
      return null
    }
    const { details, summary } = currentOrder
    return <OrderActions details={details} summary={summary} />
  }

  const renderPlusLoad = () => {
    const showPlusLoad = shouldShowPlusLoad(currentOrder)
    if (!showPlusLoad) {
      return null
    }
    const { status, qty } = currentOrder.details.plusLoadDetails
    const showSubmitted = status === PlusLoadStatus.SUBMITTED
    const showApplied = status === PlusLoadStatus.APPLIED

    const handlePlusLoadClick = () => {
      dispatch(hitGTM(UI_PLUS_LOAD_TRUCKS_PANE_GET_BTN))
      checkThenOpenPlusLoadModal({
        services,
        dispatch,
        order: currentOrder,
      })
    }
    return (
      <Grid item>
        { showSubmitted
          && (
            <Typography className={cn(classes.marginBottom1unit)} variant='body1'>
              { formatPlusLoadQuantityTextByStatus(qty, status as PlusLoadStatus.SUBMITTED) }
            </Typography>
          )
        }
        { showApplied
          && (
            <Typography className={cn(classes.marginBottom1unit)} variant='body1'>
              { formatPlusLoadQuantityTextByStatus(qty, status as PlusLoadStatus.APPLIED) }
            </Typography>
          )
        }
        <Button className={classes.boxShadow0} variant='contained' size='small' onClick={handlePlusLoadClick}>
          <ControlPointDuplicateIcon className={classes.iconLeft} />
          { UI_TEXT_GET_A_PLUS_LOAD }
        </Button>
      </Grid>
    )
  }

  if (!currentDeliveryDetails) {
    return null
  }
  const { error } = currentDeliveryDetails || {}
  const isEmptyOrder = isEmpty(get(currentDeliveryDetails, `data.orders`))
  const isError = !selectedOrderLoading && (error || isEmptyOrder)
  const { details } = currentOrder
  const noFabLg = !FEATURE_TOGGLE_FAB_BUTTONS && isWidthUp(`lg`, width)
  const noFabMd = !FEATURE_TOGGLE_FAB_BUTTONS && isWidthDown(`md`, width)
  const shouldShowFab = FEATURE_TOGGLE_FAB_BUTTONS && details
  return (
    <React.Fragment>
      <Grid item>{renderLoader()}</Grid>
      {isError && <Grid item>{renderError()}</Grid>}
      {!isEmptyOrder && (
        <div className={cn(classes.growFull, classes.detailsContainer)} ref={preserveScrollRef}>
          <Grid container item justify='space-between' spacing={2}>
            <Grid item lg={10} md={12} sm={12} xs={12}>
              <Paper classes={{ root: classes.rootContainer }}>
                { renderSummary() }
                <OrderConcreteDeliveriesDeliveredSection currentDeliveryDetails={currentDeliveryDetails} currentOrder={currentOrder} />
                <OrderConcreteDeliveriesInTransitSection currentDeliveryDetails={currentDeliveryDetails} currentOrder={currentOrder} />
                <OrderConcreteDeliveriesScheduledSection currentDeliveryDetails={currentDeliveryDetails} currentOrder={currentOrder} />
                { renderPlusLoad() }
              </Paper>
            </Grid>
            {noFabLg && (
              <Grid item lg md sm xs>
                <Paper classes={{ root: classes.section }}>{renderCallToActionSection(currentOrder)}</Paper>
              </Grid>
            )}

          </Grid>
        </div>
      )}
      {noFabMd && (
        <Grid classes={{ item: classes.section }} item>
          {renderCallToActionSection(currentOrder)}
        </Grid>
      )}

      {shouldShowFab && details &&
      (
        <SpeedDialWrapperComponent
          name='OrderConcreteDeliveriesSpeedDial'
          options={[
            getSpeedDialCallBoralOption({
              boralTel: details.boralTel,
              contactNumber: isWidthDown(`xs`, width) ? `` : details.boralTel,
              onClick: () => window.open(`tel:${details.boralTel}`, `_self`),
            }),
            getSpeedDialPlaceOrderOption({
              classes,
              onClick: () => {
                dispatch(hitGTM(UI_FAB_PLACE_ORDER_CLICK))
                history.push(createPlaceOrderPageLink())
              },
            }),
          ]}
        />
      )
      }
    </React.Fragment>
  )
}

const OrderConcreteDeliveries = compose<Props & InjectedProps, Props>(
  withServices,
  withWidth(),
  withRouter,
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesStyles) as any, { withTheme: true }),
  connect(
    () => (state, ownProps) => {
      const { orderId, services } = ownProps as any
      const orderEntitySelector = orderItemSelector(orderId)
      const currentOrder = orderEntitySelector(state)
      const { summary } = currentOrder || {}
      const { orderCode, orderLine } = summary || {}
      const status = `DELIVERED,INTRANSIT,SCHEDULED`
      const statusId = services.orderService.getStatusId({ orderCode, orderLine, status })
      const orderConcreteDeliveriesStatusSelector = orderConcreteDeliveriesStatus(statusId)
      const currentDeliveryDetails = orderConcreteDeliveriesStatusSelector(state)
      const { loading } = currentDeliveryDetails || {}
      return {
        currentDeliveryDetails,
        // currentOrder,
        selectedOrderLoading: loading,
      }
    },
  ),
)(OrderConcreteDeliveriesComponent)

export default OrderConcreteDeliveries
